import React, { useEffect } from 'react';

import { Button } from '../../../elements';
import { showError } from "../../../elements/Toasts/toastActions";
import { webhooksActions } from '../../../redux/reducers/webhooks';
import { appDetailsData } from '../../../redux/reducers/apps';
import { useAppSelector, useAppDispatch } from '../../../hooks/useRedux';
import { ReactComponent as PlusIcon } from "../../../styles/icon/plus-white.svg";
import strings from "../../../lang/lang";
import settings from '../Settings.module.scss';
import WebhookTable from './WebhookTable';
import Modals from './Modals/ModalsContainer';

function Webhooks() {
  const dispatch = useAppDispatch();
  const data = useAppSelector(appDetailsData);

  useEffect(() => {
    dispatch(webhooksActions.loadWebhooksDetails());
  }, [dispatch]);

  return (
    <div className={settings.settings__wrap_webhooks}>
      <Button
        name={strings.appWebhooks.buttons.create}
        type="submit"
        variant="primary"
        className="reverse"
        secondaryClassName="create"
        onClick={() => {
          if (data['status'] === 'BLOCKED') {
            showError(strings.appWebhooks.errors.partnerBlockedException);
          } else {
            dispatch(webhooksActions.setActiveModalDetails({ name: 'create a webhook' }));
          }
        }}
      >
        <PlusIcon />
      </Button>
      <WebhookTable />
      <Modals />
    </div>
  );
}

export default Webhooks;
